<template>
  <div class="row">
    <div class="col-md-12">
      <label>{{ $t("global.select.day") }}</label>
      <d-datepicker
        class="my-datepicker"
        calendar-class="my-datepicker_calendar"
        v-model="date"
        :disabledDates="minDays ? disabledDatesFrom : {}"
        :placeholder="fuck"
        :input-class="['form-control', 'datepicker']"
        :language="fr"
        small
      />
    </div>
    <div class="col-md-12 my-3">
      <div class="row">
        <div class="col-md-12 col-lg-6 pl-3 pr-0">
          <label>{{ $t("global.select.starting.time") }}</label>
          <div class="row pl-3">
            <div class="d-flex align-items-center justify-content-center">
              <select
                id="hourStart"
                class="form-control mt-0"
                v-model="model.startHour"
                @change="changeEndHour"
                :disabled="disabled"
              >
                <option v-for="(h, idx) in hours" :key="idx" :value="h">
                  {{ h }}
                </option>
              </select>
              <label class="text-label mx-2 mb-0">H:</label>
            </div>

            <div class="d-flex align-items-center justify-content-center">
              <select
                id="minuteStart"
                class="form-control mt-0"
                v-model="model.startMinute"
                @change="$emit('updateDate', model)"
                :disabled="disabled"
              >
                <option v-for="(m, idx) in minutes" :key="idx" :value="m">
                  {{ m }}
                </option>
              </select>
              <label class="text-label ml-2 mb-0">Min</label>
            </div>
          </div>
        </div>

        <div class="col-md-12 col-lg-6 pl-0 ending">
          <label>{{ $t("global.select.ending.time") }}</label>
          <div class="row pl-3">
            <div class="d-flex align-items-center justify-content-center">
              <select
                id="hourEnd"
                class="form-control"
                v-model="model.endHour"
                :key="model.startHour"
                @change="changeStartHour"
                :disabled="disabled"
              >
                <option
                  v-for="(h, idx) in hours"
                  :key="idx"
                  :value="h"
                  :disabled="parseInt(model.startHour, 10) > parseInt(h, 10)"
                >
                  {{ h }}
                </option>
              </select>
              <label class="text-label mx-2 mb-0">H:</label>
            </div>

            <div class="d-flex align-items-center justify-content-center">
              <select
                id="minuteEnd"
                class="form-control mt-0"
                v-model="model.endMinute"
                @change="$emit('updateDate', model)"
                :disabled="disabled"
              >
                <option
                  v-for="(m, idx) in minutes"
                  :key="idx"
                  :value="m"
                  :disabled="
                    parseInt(model.startHour, 10) ===
                      parseInt(model.endHour, 10) &&
                    parseInt(m, 10) < parseInt(model.startMinute, 10)
                  "
                >
                  {{ m }}
                </option>
              </select>
              <label class="text-label ml-2 mb-0">Min</label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import selectBox from '../shared/selectBox';
import 'bootstrap/dist/css/bootstrap.css';

// Import this component
import datePicker from 'vue-bootstrap-datetimepicker';
import { fr } from 'vuejs-datepicker/dist/locale';

// Import date picker css
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';

export default {
  name: 'DateTime',
  props: {
    disabled: Boolean,
    placeholder: String,
    minDays: Boolean,
  },
  components: {
    selectBox,
    datePicker,
  },
    async created() {
    const datepickers = await document.getElementsByClassName('datepicker');
    for (let i = 0; i < datepickers.length; i++) {
      datepickers[i].style.cursor = 'pointer';
    }
  },
  watch : {
    date(newV,oldV)
    {
      if (newV===null)
      {
        this.model.date=oldV
        this.date=oldV
        return
      }
      this.date=newV
    this.model.date=newV
    }
  },
  data() {
    return {
      date:new Date(),
      model: {
        date : new Date(),
        startHour: '00',
        startMinute: '00',
        endHour: '00',
        endMinute: '00',
      },
      hours: [
        '00',
        '01',
        '02',
        '03',
        '04',
        '05',
        '06',
        '07',
        '08',
        '09',
        '10',
        '11',
        '12',
        '13',
        '14',
        '15',
        '16',
        '17',
        '18',
        '19',
        '20',
        '21',
        '22',
        '23',
      ],
      minutes: ['00', '10', '20', '30', '40', '50'],
      disabledDatesFrom: {
        to: new Date(),
      },
      date: new Date(),
      fr,
    };
  },
  methods: {
    changeStartHour() {
      const start = parseInt(this.model.startHour, 10);
      if (start > parseInt(this.model.endHour, 10)) {
        this.model.startHour = this.model.endHour;
      }
      this.$emit('updateDate', this.model);
    },
    changeEndHour() {
      const start = parseInt(this.model.startHour, 10);
      if (parseInt(this.model.endHour, 10) < start) {
        this.model.endHour = start.toString();
      }
      if (start < 10) {
        this.model.endHour = `0${this.model.endHour}`;
      }
      this.$emit('updateDate', this.model);
    },
  },
};
</script>
<style lang="scss" scoped>
.date-picker-img {
  position: relative;
  padding: 0 17px;
  border: 1px solid #e1e5eb;
  left: 2px;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  &__icon {
    width: 12px;
    position: absolute;
    left: 11px;
    top: 9px;
  }
}

.calendar-icon {
  width: 10px;
}

.date-picker-time {
  display: flex;
  width: 100%;
}

.date-time-block {
  margin-left: 40px;
}

@media (max-width: 991px) {
  .ending {
    margin-left: 15px;
    margin-top: 15px;
  }
}

@media (max-width: 768px) {
  .date-picker-time {
    flex-direction: column;
  }

  .date-time-block {
    margin-top: 15px;
  }

  select#minuteEnd,
  select#minuteStart {
    margin-top: 10px;
  }
}

@media (max-width: 767px) {
  .my-datepicker {
    width: 150px !important;
  }
}

@media (max-width: 320px) {
  .my-datepicker {
    width: 130px !important;
  }
}

select::-ms-expand {
  display: none;
}

select {
  -webkit-appearance: none;
  appearance: none;
}

.my-datepicker {
  width: 200px;
}

.my-datepicker input {
  border-radius: 20px;
}
.datepicker{
  cursor: pointer;
}
</style>
